import { Route } from "components/utils";
import { ManufacturerItemsList } from "pages/externalManufacturerPanel/manufacturerItemsList/ManufacturerItemsList";
import { NotFound } from "pages/notFound";
import { Redirect, RouteComponentProps, Switch } from "react-router-dom";

export const ManufacturerItems = ({ match }: RouteComponentProps): JSX.Element => {
  return (
    <Switch>
      <Route
        exact={true}
        path={`${match.path}`}
        render={() => <Redirect to={`${match.path}/list/all`} />}
      />
      <Route
        exact={true}
        path={`${match.path}/list`}
        render={() => <Redirect to={`${match.path}/list/all`} />}
      />
      <Route
        component={ManufacturerItemsList}
        exact={true}
        path={`${match.path}/list/:tab`}
        title="Milo - zlecenia produkcyjne"
      />
      <Route component={NotFound} exact={true} path="*" title="Milo" />
    </Switch>
  );
};
